import { styled } from '@mui/material';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';

export const Wrapper = styled(Container)(({ theme }) => ({
	position: 'relative',
	padding: 0,
	width: '100%',

	[theme.breakpoints.down('md')]: {
		padding: 0,
	},
	[theme.breakpoints.up('md')]: {
		padding: 0,
	},
}));

export const ItemContainer = styled('div')(({ theme }) => ({
	marginRight: theme.spacing(2),
}));

export const NavigationButton = styled(IconButton)(({ theme }) => ({
	position: 'absolute',
	top: '45%',
	width: 44,
	height: 44,
	color: theme.colors.text,
	backgroundColor: '#fff',
	border: '1px solid rgba(0, 0, 0, 0.08)',
	boxShadow: '0 4px 14px rgba(0, 0, 0, 0.12)',
	zIndex: theme.zIndex.appBar,
	transition: 'transform 0.15s ease, color 0.15s ease',

	'&:hover': {
		backgroundColor: '#fff',
		color: theme.colors.brand,
		transform: 'scale(1.08)',
	},

	[theme.breakpoints.down('md')]: {
		display: 'none',
	},
}));

export const NavigationButtonLeft = styled(NavigationButton)(() => ({
	left: 0,
}));

export const NavigationButtonRight = styled(NavigationButton)(() => ({
	right: 0,
}));
